import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { DsLink as n } from "@frontends/ds";
import { DsIcon as r } from "@frontends/ds-icons";
import { useTranslation as i } from "react-i18next";
//#region src/lib/constants.ts
var a = "ui-spg-layout";
//#endregion
//#region src/lib/Page.tsx
function o({ children: t }) {
	return /* @__PURE__ */ e("div", {
		className: "mx-auto flex w-full max-w-6xl min-w-0 flex-col gap-6",
		children: t
	});
}
//#endregion
//#region src/lib/PageHeader.tsx
function s({ actions: o, status: s, title: c, trail: l = [] }) {
	let { t: u } = i(a);
	return /* @__PURE__ */ t("header", {
		className: "flex min-h-10 flex-wrap items-center justify-between gap-x-6 gap-y-3",
		children: [/* @__PURE__ */ e("nav", {
			"aria-label": u("breadcrumb"),
			className: "min-w-0",
			children: /* @__PURE__ */ t("ol", {
				className: "flex min-w-0 items-center gap-2 text-2xl",
				children: [l.map((i) => /* @__PURE__ */ t("li", {
					className: "flex shrink-0 items-center gap-2",
					children: [/* @__PURE__ */ e(n, {
						href: i.href,
						variant: "subtle",
						children: i.label
					}), /* @__PURE__ */ e(r, {
						name: "chevron-right",
						size: "sm",
						"aria-hidden": !0,
						className: "text-textTertiary"
					})]
				}, i.href)), /* @__PURE__ */ t("li", {
					"aria-current": "page",
					className: "flex min-w-0 items-center gap-3",
					children: [/* @__PURE__ */ e("h1", {
						className: "truncate font-semibold text-textPrimary",
						children: c
					}), s]
				})]
			})
		}), o && /* @__PURE__ */ e("div", {
			className: "flex flex-wrap items-center gap-3",
			children: o
		})]
	});
}
//#endregion
//#region src/lib/PropertyList.tsx
function c({ items: n }) {
	return /* @__PURE__ */ e("dl", {
		className: "flex flex-col text-base",
		children: n.map((n) => /* @__PURE__ */ t("div", {
			className: "grid grid-cols-1 gap-x-6 gap-y-1 border-t border-borderSecondary py-3 sm:grid-cols-[12rem_minmax(0,1fr)]",
			children: [/* @__PURE__ */ e("dt", {
				className: "text-textSecondary",
				children: n.label
			}), /* @__PURE__ */ e("dd", {
				className: "min-w-0 break-words text-textPrimary",
				children: n.value
			})]
		}, n.label))
	});
}
//#endregion
//#region src/lib/RowList.tsx
function l({ children: t }) {
	return /* @__PURE__ */ e("ul", {
		className: "flex flex-col text-base",
		children: t
	});
}
function u({ action: n, children: r }) {
	return /* @__PURE__ */ t("li", {
		className: "flex min-h-12 items-center gap-3 border-t border-borderSecondary py-3",
		children: [/* @__PURE__ */ e("div", {
			className: "flex min-w-0 flex-1 flex-col gap-0.5",
			children: r
		}), n && /* @__PURE__ */ e("div", {
			className: "flex shrink-0 items-center gap-2",
			children: n
		})]
	});
}
//#endregion
export { o as Page, s as PageHeader, c as PropertyList, l as RowList, u as RowListItem, a as UI_SPG_LAYOUT_NAMESPACE };
